<template>
  <div 
    class="fts-automation-node-if-else automation-node" 
    :class="{ 
      'automation-node--debug': data.debug, 
      'automation-node--debugging': isDebugging,   
    }">
    <div class="node-header">
      <div class="node-header__label">
        <i class="fts-icon-automation-condition node-header-icon" />
        <div class="node-header-title">Condition</div>
      </div>
      <div class="node-header__action">
        <fts-automation-debugpoint
          v-model="data.debug"
          class="node-header__debugpoint"
          @input="updateData"
        />
      </div>
    </div>
    <div class="node-body">
      <fts-formula
        v-model="data.condition"
        :variables="data.variables"
        class="automation-formula-form-control"
        @input="updateData"
      />
      <!-- <div class="variable">
        <fts-automation-scoped-variables :variables="data.variables" />
      </div> -->
    </div>
  </div>
</template>

<script>
import { automationDesignStore } from "../../store/automationDesignStore";

import FTSFormula from "../../design/FTSFormula.vue";
import FTSAutomationScopedVariables from "./FTSAutomationScopedVariables";
import FTSAutomationDebugpoint from "./FTSAutomationDebugpoint";

export default {
  props: {
    data: Object,
    inputs: Array,
    information: Array,
  },
  components: {
    "fts-formula": FTSFormula,
    "fts-automation-scoped-variables": FTSAutomationScopedVariables,
    "fts-automation-debugpoint": FTSAutomationDebugpoint,
  },
  data() {
    return {
      editor: null,
      show: -1,
      content: "",
      isDebugging: false,
    };
  },
  methods: {
    updateData() {
      this.$forceUpdate();
    },
  },
  computed: {
    variables() {
      return automationDesignStore.state.variables;
    },
  },
  mounted() {
    let vm = this;

    window.eventBus.$on("refreshAutomationBlocks", () => {
      vm.isDebugging = false;
      if (automationDesignStore.state.debugPayload && automationDesignStore.state.debugPayload.nodeId) {
        let nodeId = automationDesignStore.state.debugPayload.nodeId;
        let diagram = automationDesignStore.state.diagram;
        if(diagram[nodeId].data.id == vm.data.id) {
          vm.isDebugging = true;
        }
      }

      vm.$forceUpdate();
    });
  },
  beforeDestroy() {
    window.eventBus.$off("refreshAutomationBlocks");
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";
</style>